export default __webpack_public_path__ + "static/media/canvasBgDemo.b018cf42.png";